import { useContext, useEffect, useState } from "react";

import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";

import version from "../../app/constants/versionConstant"
import { ErrorManagementContext } from "../../utils/errorManagement/ErrorManagementProvider";
import styles from "./versionChecker.module.css"
import VersionContent from "./VersionContent";

const VersionChecker = () => {
    const currentVersion = version
    const [newVersionAvailable, setNewVersionAvailable] = useState(false);
    const { cookClubLog } = useContext(ErrorManagementContext);

    useEffect(() => {
        const fetchVersion = async () => {
            try {
                const response = await fetch(`${window.location.origin}/version.json`, {
                    cache: "no-cache",
                });
                if (!response.ok) {
                    throw new Error("Failed to fetch version.json");
                }

                const data = await response.json();
                const appVersion = data.version;
                if (currentVersion !== appVersion) {
                    setNewVersionAvailable(true);
                }

            } catch (error) {
                cookClubLog(`Error fetching version.json.`, "", {}, { ui: { type: "error" }, browserConsole: true });
            }
        };

        fetchVersion();
    }, [currentVersion]);

    return (

        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            className={styles.position}
            id='installPromptsSnackbar'
            open={newVersionAvailable}
        >
            <SnackbarContent
                classes={{
                    root: styles.snackbar_content,
                    message: styles.message,
                }}
                id='installPromptsSnackbarContent'
                message={<VersionContent />}
            />
        </Snackbar>

    );
};

export default VersionChecker;
